import React, { useState, useEffect } from "react";
// import { useCookies } from "react-cookie";
import { useParams, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import "./index.css";
import axios from "axios";
import ModelCard from "./ModelCard";
import FileUploadTestModel from "./FileUploadTestModel";
import Comment from "../../components/Comment";
import { updateAlert, updateModels } from "../../redux/actions";
import Plot from "../../components/Plot";
import LinkUploadTestModel from "./LinkUploadTestModel";
import Star from "../../components/Star";
import deepCopy from "../../../../utils/deepcopy";
import RejectReasonDialog from "./RejectReasonDialog";
import { Avatar as MuiAvatar, AvatarGroup } from "@mui/material";
import Avatar, { genConfig } from 'react-nice-avatar';
import { stringAvatar } from "../../../../utils/muiAvatar";
import Divider from "../../components/Divider";

function ModelPage(props) {
  const navigate = useNavigate();
  // const [cookies, setCookies] = useCookies([""]);
  const mid = parseInt(useParams().mid);
  const [model, setModel] = useState({});
  const [sampleData, setSampleData] = useState("");
  const [rejectReasonOpen, setRejectReasonOpen] = useState(false)
  const [modelCard, setModelCard] = useState("");
  const [stared, setStared] = useState(false);
  const [numOfStars, setNumOfStars] = useState("Loading...");
  const [starFlag, setStarFlag] = useState(false);
  const [starAnimate, setStarAnimate] = useState(false);

  useEffect(() => {
    if (!props.user.id) {
      navigate("/");
    }

    axios({
      method: "post",
      url: `/api/m2d/models/getModelById`,
      data: {
        uid: props.user.id,
        mid: mid
      }
    }).then((res) => {
      if (!res.data || res.data === "Access denied!") {
        navigate("/m2d/models");
      } else {
        setModel(res.data.result);
        // const tab = document.cookie.includes("acceptedCookiePolicy=true") && cookies[`tab${res.data.result.id}`] !== undefined
        //   ? parseInt(cookies[`tab${res.data.result.id}`])
        //   : 0
        setSampleData(res.data.sampleData);
        setModelCard(res.data.modelCard);
        setNumOfStars(res.data.result.m2dModelStars.length);
      }

    }).catch(err => {
      console.log(err);
      navigate("/m2d/models");
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    axios({
      method: "get",
      url: `/api/m2d/modelstar/getStarStatus/${props.user.id}/${mid}`
    }).then((res) => {
      if (res.data) {
        setStared(true);
        setTimeout(() => {
          setStarAnimate(true);
        }, 500);
      } else {
        setStarAnimate(true);
      }
    }).catch(err => {
      console.log(err);
    })
  }, [props, mid]);

  const handleReject = () => {
    if (model.approveStatus === 'Rejected') {
      setRejectReasonOpen(true);
    }
  }

  const handleRejectReasonClose = () => {
    setRejectReasonOpen(false);
  }

  const handleOwner = (uid) => {
    navigate(`/m2d/profile?uid=${uid}`);
  }

  const handleStar = async () => {
    if (!starFlag) {
      if (stared) {
        setNumOfStars(curr => curr -= 1);
        try {
          await axios({
            method: "post",
            url: "/api/m2d/modelstar/remove",
            data: {
              uid: props.user.id,
              mid: mid
            }
          });
          const newModels = deepCopy(props.models);
          newModels?.m2dModelStars?.filter(ms => ms.userId !== props.user.id);
          props.handleModels(newModels);
        } catch (err) {
          props.handleAlert("error", err.message, 3000);
          console.log(err);
        }
      } else {
        setStarFlag(true);
        setNumOfStars(curr => curr += 1);
        try {
          await axios({
            method: "post",
            url: "/api/m2d/modelstar/create",
            data: {
              uid: props.user.id,
              mid: mid
            }
          })
          const newModels = deepCopy(props.models);
          newModels?.m2dModelStars?.push({ userId: props.user.id });
          console.log(newModels);
          props.handleModels(newModels);
        } catch (err) {
          props.handleAlert("error", err.message, 3000);
          console.log(err);
        } finally {
          setTimeout(() => {
            setStarFlag(false);
          }, 1500);
        }

      }
      setStared(curr => !curr);
    }

  }

  const handleProject = (pid) => () => {
    navigate(`/m2d/projects/${pid}`);
  }

  return (
    <div className="page-content">
      <div className="model-pg-content">
        <div className="model-page-content">
          <div className="model-pg-title">
            <div className="title-content">
              <div className="avatar">
                <AvatarGroup max={3}>
                  {model.users && model.users.map((user, index) => {
                    return <div key={user.id} onClick={() => handleOwner(user.id)}>
                      {user.avatar ? (
                        <MuiAvatar key={user.id}><Avatar style={{ width: '29px', height: '29px' }} {...genConfig(JSON.parse(user.avatar))} /></MuiAvatar>
                      ) : (
                        <MuiAvatar {...stringAvatar(`${user.firstName} ${user.lastName}`, {}, true, true)} key={user.id} />
                      )}
                    </div>
                  }
                  )}
                </AvatarGroup>
              </div>
              {model.name}
            </div>
            <div className="title-left">
            </div>

            <div className="title-right">
              {model.users && model.users.find(user => user.id === props.user.id) ? (
                <div className={`model-pg-status${model.approveStatus === 'Rejected' ? '-rejected'
                  : (
                    model.approveStatus === 'Approved' ? '-approved'
                      : ''
                  )
                  }`} onClick={handleReject}>{model.approveStatus}</div>
              ) : null}
              <div className="model-star" onClick={handleStar}>
                <Star stared={stared} total={numOfStars} animate={starAnimate} />
              </div>
            </div>
          </div>

          {/* <div className="model-pg-owners">
        {model?.users?.map((user, index) => {
          return <span onClick={() => handleOwner(user.id)} key={index}>{`${user.firstName} ${user.lastName}${index === model.users.length - 1 ? "" : ", "}`}</span>
        })}
      </div> */}

          {model.approveStatus === "Approved" ? (
            <div style={{ display: 'flex' }}>
              <div className="model-card-block">
                <ModelCard model={model} modelCard={modelCard} />
              </div>
              <div className="right-block">
                <div className="test-model-block">
                  <div className="right-block-title">
                    Test Model
                  </div>
                  {model.m2dModelInputType.type === 'signal' ? (
                    <FileUploadTestModel
                      model={model}
                      sampleData={sampleData}
                      uid={props.user.id}
                      usertype={props.role}
                      handleAlert={props.handleAlert}
                    />
                  ) : null}
                  {model.m2dModelInputType.type === 'link' ? (
                    <LinkUploadTestModel
                      model={model}
                      uid={props.user.id}
                      usertype={props.role}
                      handleAlert={props.handleAlert}
                    />
                  ) : null}
                </div>
                {model.m2dProjects && model.m2dProjects.length > 0 && <><Divider />
                  <div className="model-pg-project">
                    <div className="right-block-title">Projects</div>
                    <div className="model-pg-project-list">
                      {model.m2dProjects.map((project) => (
                        <div className="item" key={project.id} onClick={handleProject(project.id)}>
                          {project.title}
                        </div>))}
                    </div>
                  </div></>}
                <Divider />
                <div className="model-comment-block">
                  <div className="right-block-title">
                    Comments
                  </div>
                  <Comment
                    model={model}
                    user={props.user}
                    handleAlert={props.handleAlert}
                  />
                </div>
              </div>
            </div>
          ) : (
            <>
              {sampleData &&
                <div className="example-plot" style={{ marginTop: '20px' }}>
                  {sampleData.length > 0 && sampleData.map((data, index) =>
                    <div key={index}>
                      <div className="example-plot-title">Sample signal (Frequency: {data.frequency}hz)</div>
                      <Plot
                        filename={`${model.exampleFile}.json`}
                        contents={data.signal}
                        frequency={data.frequency}
                        height={50}
                        grid={0}
                        resultId={-1}
                        groundTruth={-1}
                      />
                    </div>
                  )}
                </div>
              }
              <div className="model-card">
                <ModelCard model={model} modelCard={modelCard} />
              </div>
            </>
          )}
          {/* ---------- reject reason dialog ---------- */}
          {model.m2dModelRejects && model.m2dModelRejects.length > 0 &&
            <RejectReasonDialog
              rejectReasonOpen={rejectReasonOpen}
              handleRejectReasonClose={handleRejectReasonClose}
              model={model}
            />
          }
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.main.user,
    models: state.m2d.models,
    unapprovedModels: state.m2d.unapprovedModels,
    role: state.m2d.role
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleModels(models) {
      updateModels(models)(dispatch);
    },

    handleAlert(alertType, alertMessage, time = 2500) {
      updateAlert(alertType, alertMessage, time)(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModelPage);
